module.exports = "<div class=\"error-view hidy\"> <h3 class=error--title></h3> <p class=error--text></p> </div> ";